import blankAction from '../assets/images/bbBlankAction.png'
import getAction from './getAction'

function getLastRoundActionFromSlots(combatant, maxCA) {
  // loop through combatant's actions in reverse order to find the last valid action
  for (let actionNum = maxCA; actionNum >= 1; actionNum--) {
    const imageField = 'ca' + actionNum
    const nameField = 'ca_name' + actionNum
    const typeField = 'ca_type' + actionNum

    console.log(
      'actionNum = ',
      actionNum,
      ' / typeField = ',
      typeField,
      ' / combatant[typeField] = ',
      combatant[typeField],
    )

    if (
      combatant[typeField] == 'action' &&
      combatant[nameField] != 'pending' &&
      combatant[nameField] != 'blank'
    ) {
      console.log('got image')
      return {
        image: combatant[imageField],
        name: combatant[nameField],
        action: getAction(combatant[nameField]) ?? null,
      }
    }
  }

  return null
}

function getLastRoundActionFromCollection(combatant, maxCA, currentRound) {
  if (!Number.isFinite(currentRound) || !Array.isArray(combatant?.actions)) {
    return null
  }

  const actionEntry = combatant.actions
    .filter(
      (action) =>
        action?.round === currentRound &&
        Number.isFinite(action?.number) &&
        action.number >= 1 &&
        action.number <= maxCA &&
        action?.action_name !== 'pending' &&
        action?.action_name !== 'blank',
    )
    .sort((left, right) => right.number - left.number)[0]

  if (!actionEntry) {
    return null
  }

  return {
    image: actionEntry.action_image || blankAction,
    name: actionEntry.action_name,
    action: getAction(actionEntry.action_name) ?? null,
  }
}

export default function getCombatantLastRoundAction(combatant, maxCA, currentRound = null) {
  console.log('----------------------------------------------------------------------------------')
  console.log('IN getCombatantLastRoundAction combatant = ', combatant.name, ' maxCA = ', maxCA)

  console.log('combatant snapshot = ', JSON.parse(JSON.stringify(combatant)))

  const slotAction = getLastRoundActionFromSlots(combatant, maxCA)

  if (slotAction) {
    return slotAction
  }

  const collectionAction = getLastRoundActionFromCollection(combatant, maxCA, currentRound)

  if (collectionAction) {
    console.log('got image from actions collection')
    return collectionAction
  }

  console.log('gonna be blank image')
  return {
    image: blankAction,
    name: 'blank',
    action: null,
  }
}
